export default __webpack_public_path__ + "static/walletconnect-9b7e021b5c269a91a9163d18e8acdfe3.png";